import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

export interface UpdateResponse {
  data: {
    success: boolean;
  };
}

type UpdateParams =
  | {
      is_hubspot_integrated: boolean;
    }
  | {
      is_salesforce_integrated: boolean;
    }
  | {
      is_pipedrive_integrated: boolean;
    }
  | {
      is_msdynamics365sales_integrated: boolean;
    }
  | {
      is_jobadder_integrated: boolean;
    };

export const useUpdateCustomer = () => {
  return useMutation<UpdateResponse, Error, UpdateParams>({
    mutationFn: async (data) => {
      return axios.put(`${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/customer/update`, {
        data,
      });
    },
    onError: (error) => {
      console.error(error);
    },
  });
};
